export const OperatingUsers = ["Cashier"];
export const Operator = ["Operator"];
export const Supervisor = ["Supervisor"];
export const Manager = ["Manager"];
export const Admin = ["Admin"];
export const Developer = ["Developer"];
export const Telesales = ["TeleSales"];

